export default "__VITE_ASSET__BsInFzHd__"